module.exports = __webpack_public_path__ + "static/media/paymentSuccess.bbfa1517.png";